import React, { useEffect } from "react";
import "../../styles/dashboard.css";
import TopBar from "../NavBar/TopBar";
import { useSelector } from "react-redux";
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation,useNavigate } from 'react-router-dom';
import PrivateRoute from "../../routes/private_route";
import CMSRoute from "../../routes/cms_route";
import ListCompanies from "../../Pages/CompaniesList/ListCompanies";
import ListUsers from "../../Pages/Users/ListUsers";
import ListRoles from "../../Pages/ListRolesNewUI/ListRoles";
import ListPermissions from "../../Pages/ListPermissions/ListPermissions";
import Userlogin from "../Login/userlogin";
import ListLicenses from "../../Pages/ListLicences/ListLicenses";
import HomeUms from "../../Pages/HomeUms/HomeUms";
import HomeCms from "../../Pages/HomeCms/HomeCms";
import ContentList from "../../Pages/ContentList/ContentList";
import CreateUpdateRole from "../../Pages/ListRolesNewUI/CreateUpdateRole";
import AddEdit from "../../Pages/Users/AddEdit";
import ForgotPassword from "../Login/forgetPassword";
import Webpage from '../Login/webpage';
import ResetPassword from "../../Pages/PasswordPages/ResetPassword";
import PastSession from "../../Pages/ContentList/PastSession";
import NewHomeUMS from "../../Pages/NewHomeUMS/NewHomeUMS";
import ListDevices from "../../Pages/ListDevices/ListDevices";
import Adddevice from "../../Pages/ListDevices/Adddevice";
import ContentRecycle from "../../Pages/ContentRecycle/ContentRecycle";
import "./MainComponent.css";
import { useDispatch } from 'react-redux';
import { loginReducer, sidebarReducer } from "../../Redux/store";
import { AccessTockenReducer } from "../../Redux/store";
import { permissionsReducer } from "../../Redux/store";

const MainContentWrapper = ({ children }) => (
  <div>
    <TopBar />
    <div className="app-content">
      {children}
    </div>
  </div>
);

const InnerComponent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    
    dispatch(AccessTockenReducer.userType("platform"));
    const queryParams = new URLSearchParams(location.search);
    const dataParam = queryParams.get('data');

    if (dataParam) {
      try {
        const parsedData = JSON.parse(decodeURIComponent(dataParam)); 
        console.log("abbbbbbbbbbb",parsedData); 

        const accessTKN = parsedData.access_token;      
        const loginUserId = parsedData.user_details.te_userid;
        const user_Name = parsedData.user_details.te_username;
        const userRoleType =  parsedData.userRoleType;
        const vrdevicecode =  parsedData.vrdevicecode;
        const userdata = parsedData.user_details;
        const permissions = parsedData.permissions.modules;
       
         
        sessionStorage.setItem("isLogin", true);
        localStorage.setItem('access_token', accessTKN);
        sessionStorage.setItem("access_token", accessTKN);
        sessionStorage.setItem("userdata", JSON.stringify(userdata));
        sessionStorage.setItem("permissions",JSON.stringify(permissions));
        sessionStorage.setItem("userRoleType",userRoleType);
        sessionStorage.setItem("vrdevicecode", vrdevicecode);
        dispatch(loginReducer.Login());
        dispatch(loginReducer.Login_UserId(loginUserId));
        dispatch(permissionsReducer.setPermissions(permissions));
        dispatch(AccessTockenReducer.accessTocken(accessTKN));
        dispatch(loginReducer.Login_UserName(user_Name));
        navigate("/newhome-ums");
        // window.open(
        //   `${process.env.REACT_APP_UNITY_WEBGL_URL}?accessToken=${accessTKN}`,
        //   "_blank"
        // );
      } catch (error) {
        console.error("Error parsing data:", error);
      }
    }
  }, [location]);

  return (
    <Routes>
      <Route path="/home-cms" element={<PrivateRoute ><CMSRoute><MainContentWrapper><HomeCms /></MainContentWrapper></CMSRoute></PrivateRoute>} />
          <Route path="/Content-recyle" element={<PrivateRoute ><CMSRoute><MainContentWrapper><ContentRecycle /></MainContentWrapper></CMSRoute></PrivateRoute>} />
          {/* <Route path="/past-session" element={<PrivateRoute ><CMSRoute><MainContentWrapper><PastSession /></MainContentWrapper></CMSRoute></PrivateRoute>} /> */}
          <Route path="/content-list" element={<PrivateRoute ><CMSRoute><MainContentWrapper><ContentList /></MainContentWrapper></CMSRoute></PrivateRoute>} />
          <Route path="/past-session" element={<PrivateRoute><CMSRoute><MainContentWrapper><PastSession /></MainContentWrapper></CMSRoute></PrivateRoute>} />
    
          {/* sessionStorage.getItem("userRoleType")=="Cms_user" ?  */}
            <Route path="/home-ums" element={<PrivateRoute ><CMSRoute><MainContentWrapper><HomeUms /></MainContentWrapper></CMSRoute></PrivateRoute>} />
            <Route path="/role-creation" element={<PrivateRoute ><CMSRoute><MainContentWrapper><CreateUpdateRole /></MainContentWrapper></CMSRoute></PrivateRoute>} />
            <Route path="/role-update" element={<PrivateRoute ><CMSRoute><MainContentWrapper><CreateUpdateRole /></MainContentWrapper></CMSRoute></PrivateRoute>} />
            <Route path="/list-details" element={<PrivateRoute ><CMSRoute><MainContentWrapper><ListCompanies /></MainContentWrapper></CMSRoute></PrivateRoute>} />
            <Route path="/list-users" element={<PrivateRoute ><CMSRoute><MainContentWrapper><ListUsers /></MainContentWrapper></CMSRoute></PrivateRoute>} />
            <Route path="/list-roles" element={<PrivateRoute ><CMSRoute><MainContentWrapper><ListRoles /></MainContentWrapper></CMSRoute></PrivateRoute>} />
            <Route path="/list-devices" element={<PrivateRoute ><CMSRoute><MainContentWrapper><ListDevices /></MainContentWrapper></CMSRoute></PrivateRoute>} />
            <Route path="/list-permissions" element={<PrivateRoute ><CMSRoute><MainContentWrapper><ListPermissions /></MainContentWrapper></CMSRoute></PrivateRoute>} />
            <Route path="/add" element={<PrivateRoute ><CMSRoute><MainContentWrapper><AddEdit /></MainContentWrapper></CMSRoute></PrivateRoute>} />
            <Route path="/add-device" element={<PrivateRoute ><CMSRoute><MainContentWrapper><Adddevice /></MainContentWrapper></CMSRoute></PrivateRoute>} />
            <Route path="/edit" element={<PrivateRoute ><CMSRoute><MainContentWrapper><AddEdit /></MainContentWrapper></CMSRoute></PrivateRoute>} />
            {/* <Route path="/webpage" element={<PrivateRoute ><MainContentWrapper><AddEdit /></MainContentWrapper></PrivateRoute>} /> */}
            <Route path="/newhome-ums" element={<PrivateRoute ><CMSRoute><MainContentWrapper><NewHomeUMS /></MainContentWrapper></CMSRoute></PrivateRoute>} />

            {/* <Route path="/app-down" element={<PrivateRoute > <AppDown /> </PrivateRoute>} /> */}
            <Route path="/list-licenses" element={<PrivateRoute ><MainContentWrapper><ListLicenses /></MainContentWrapper></PrivateRoute>} />

            <Route path="/login" element={<Userlogin />} />

            {/* </Route> */}
            <Route path="/" element={sessionStorage.getItem("access_token") ? <Navigate to="/newhome-ums" /> : <Navigate to="/login" />} />
            <Route path="/forgetPassword" element={<ForgotPassword/>}/>
            <Route path="/resetPassword" element={<ResetPassword/>}/>
            <Route path="/webpage" element={<Webpage/>}/>
         
           
  {/* <Route path="/resetPassword/:id" element={<ResetPassword/>}/> */}
      {/* <Route path="/home-cms" element={<PrivateRoute><CMSRoute><MainContentWrapper><HomeCms /></MainContentWrapper></CMSRoute></PrivateRoute>} />
      <Route path="/content-recycle" element={<PrivateRoute><CMSRoute><MainContentWrapper><ContentRecycle /></MainContentWrapper></CMSRoute></PrivateRoute>} />
      <Route path="/content-list" element={<PrivateRoute><CMSRoute><MainContentWrapper><ContentList /></MainContentWrapper></CMSRoute></PrivateRoute>} />
      <Route path="/past-session" element={<PrivateRoute><CMSRoute><MainContentWrapper><PastSession /></MainContentWrapper></CMSRoute></PrivateRoute>} />
      <Route path="/home-ums" element={<PrivateRoute><CMSRoute><MainContentWrapper><HomeUms /></MainContentWrapper></CMSRoute></PrivateRoute>} />
      <Route path="/role-creation" element={<PrivateRoute><CMSRoute><MainContentWrapper><CreateUpdateRole /></MainContentWrapper></CMSRoute></PrivateRoute>} />
      <Route path="/role-update" element={<PrivateRoute><CMSRoute><MainContentWrapper><CreateUpdateRole /></MainContentWrapper></CMSRoute></PrivateRoute>} />
      <Route path="/list-details" element={<PrivateRoute><CMSRoute><MainContentWrapper><ListCompanies /></MainContentWrapper></CMSRoute></PrivateRoute>} />
      <Route path="/list-users" element={<PrivateRoute><CMSRoute><MainContentWrapper><ListUsers /></MainContentWrapper></CMSRoute></PrivateRoute>} />
      <Route path="/list-roles" element={<PrivateRoute><CMSRoute><MainContentWrapper><ListRoles /></MainContentWrapper></CMSRoute></PrivateRoute>} />
      <Route path="/list-devices" element={<PrivateRoute><CMSRoute><MainContentWrapper><ListDevices /></MainContentWrapper></CMSRoute></PrivateRoute>} />
      <Route path="/list-permissions" element={<PrivateRoute><CMSRoute><MainContentWrapper><ListPermissions /></MainContentWrapper></CMSRoute></PrivateRoute>} />
      <Route path="/add" element={<PrivateRoute><CMSRoute><MainContentWrapper><AddEdit /></MainContentWrapper></CMSRoute></PrivateRoute>} />
      <Route path="/add-device" element={<PrivateRoute><CMSRoute><MainContentWrapper><Adddevice /></MainContentWrapper></CMSRoute></PrivateRoute>} />
      <Route path="/edit" element={<PrivateRoute><CMSRoute><MainContentWrapper><AddEdit /></MainContentWrapper></CMSRoute></PrivateRoute>} />
      <Route path="/newhome-ums" element={<PrivateRoute><CMSRoute><MainContentWrapper><NewHomeUMS /></MainContentWrapper></CMSRoute></PrivateRoute>} />
      <Route path="/list-licenses" element={<PrivateRoute><MainContentWrapper><ListLicenses /></MainContentWrapper></PrivateRoute>} />
      <Route path="/login" element={<Userlogin />} />
      <Route path="/forgetPassword" element={<ForgotPassword />} />
      <Route path="/resetPassword" element={<ResetPassword />} />
      <Route path="/webpage" element={<Webpage />} /> */}
    </Routes>
  );
};

function MainComponent() {
  const toggled = useSelector((state) => state.AccessTocken.sidebarToggle);

  return (
    <div className={`app ${toggled ? "toggled" : ""}`}>
      <div className="align-sidenav"></div>
      <main>
        <Router>
          <InnerComponent />
        </Router>
      </main>
    </div>
  );
}

export default MainComponent;
